import Memory1 from '../../../images/memory_1.png'
import Memory2 from '../../../images/memory_2.png'
import Memory3 from '../../../images/memory_3.png'
import Memory4 from '../../../images/memory_4.png'

export const ITEM_LIST = [
    {
        image: Memory1,
        title: 'LẦN ĐẦU CHÚNG MÌNH GẶP NHAU',
        description: 'Nhớ ngày đầu gặp mặt, chắc là ngày mà chúng mình không bao giờ quên. Lần đầu gặp mặt chính là ngày mà chúng mình chung lớp cấp 3, và để rồi câu chuyện bắt đầu từ đó...',
    },
    {
        image: Memory2,
        title: 'LẦN ĐẦU HẸN HÒ',
        description: 'Là bạn chung lớp cấp 3, tuy nhiên tụi mình thật sự lại không có được buổi chơi riêng với nhau. Và để rồi ngày đầu tiên hẹn hò chính là những ngày tháng rời xa nhà và lên Sài Gòn phồn hoa để bước chân vào con đường đại học.',
    },
    {
        image: Memory3,
        title: 'LỜI CẦU HÔN',
        description: 'Ngày đó là ngày mà mình không bao giờ quên, anh chuẩn bị mọi thứ một cách bất ngờ. Cảm xúc lúc đó mình không thể diễn tả bằng lời, mình đã khóc rất nhiều, khóc vì sung sướng trong hạnh phúc.',
    },
    {
        image: Memory4,
        title: 'NGÀY HẠNH PHÚC',
        description: 'Vậy là câu chuyện của chúng mình sẽ được viết tiếp bằng ngày hạnh phúc nhất đời chúng mình, ngày 4/12/2022 tới đây. Ngoài ra chúng mình vẫn còn một buổi lễ Báo Hỷ được tổ chức trên Sài Gòn nên bạn đừng lo nếu không kịp tham dự ngày 4/12 nhé. Hy vọng bạn có thể đến tham dự và chung vui cùng chúng mình!',
    }
]
